import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyButton } from '@dfx.swiss/react-components';
import copy from 'copy-to-clipboard';
import QRCode from 'react-qr-code';
export function QrCopy({ data }) {
    return (_jsxs("div", Object.assign({ className: "relative w-full max-w-[20rem]" }, { children: [_jsx("div", Object.assign({ className: "absolute bg-white border p-1 rounded-sm top-1/2 left-1/2", style: { transform: 'translate(-50%, -50%)' } }, { children: _jsx(CopyButton, { onCopy: () => copy(data) }) })), _jsx(QRCode, { className: "mx-auto h-auto w-full", value: data, size: 128, fgColor: '#072440' })] })));
}
